'use strict'

import axios from 'axios';

export default{
    install:(Vue, config)=>{

        const apiUrl=config && config.apiUrl ? config.apiUrl : '';
        const docUrl = config && config.docUrl ? config.docUrl : '';
        const authToken = config && config.authToken ? config.authToken : 'Bearer';  

        Vue.prototype.$http = axios;
        Vue.prototype.$apiUrl = apiUrl;
        Vue.prototype.$authToken = authToken;
        Vue.prototype.$docUrl = docUrl;
    }
}